import React from "react";

import {
  BrowserRouter as Router,
  Navigate
} from "react-router-dom";

import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/messaging';

import {
  ToastContainer,
  Slide
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  ErrorHandler
} from 'components';

import {
  AuthenticationProvider,
  ThemeProvider
} from 'providers';

import AppRoutes from './AppRoutes';

import {
  firebaseConfig
} from 'firebaseConfig';

// ...
// Firebase configuration.
firebase.initializeApp(firebaseConfig);

if (firebase.messaging.isSupported()) {
  firebase.messaging().onMessage((payload) => {
    console.log('Message received. ', payload);
  });
}

// ...

function App() {
  return (
    <Router>
      <ToastContainer
        position="bottom-center"
        transition={Slide}
        hideProgressBar
      />
      <ErrorHandler fallback={({ error }) => <Navigate to="/error" state={{ error }} />}>
        <ThemeProvider>
          <AuthenticationProvider>
            <AppRoutes />
          </AuthenticationProvider>
        </ThemeProvider>
      </ErrorHandler>
    </Router>
  );
}

export default App;
